<!--<div class="pagebrk"></div>
  <printheaderview>
  </printheaderview>-->
<div class="row" *ngIf="RXLaserPrint == 'true'">
  <div class="col-print-12 padding-left-0px">
    <div class="card background-color-wt">

      <div class="card-body padding-top-0px padding-bottom-0px font-weight-normal background-color-wt">

        <div class="row bordertop5px">
          <div class="col-print-12 text-align-center">
            <label class="font-familyhead margin-bottom-0px">Pharmacy Bill</label>
            <!--<qrcode class="padding-top-0px padding-bottom-0px qr-style7" [qrdata]="PatientId" [size]="90" [level]="'M'"></qrcode>-->
          </div>
        </div>

        <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <div class="row margin-left-0px margin-right-0px" *ngIf="CurrentX_BillHeaderController && RXPrintBodyWithPatientDetails == 'true'">
                <div class="col-print-4">
                  <label class="margin-bottom-0px  font-weight-normal">Patient Name:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px  float-left font-weight-bold">{{CurrentX_BillHeaderController.PatientName}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px" *ngIf="CurrentX_BillHeaderController && RXPrintBodyWithPatientDetails == 'true'">
                <div class="col-print-4">
                  <label class="margin-bottom-0px  font-weight-normal">ID:</label>
                </div>
                <div class="col-print-8" *ngIf="!CurrentX_BillHeaderController.IsGuest">
                  <label class="margin-bottom-0px  float-left font-weight-bold">{{CurrentX_BillHeaderController.PatientFormattedCode}}</label>
                </div>
              </div>

              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Receipt No:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-bold">{{ReceiptFormattedCode}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Date:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{BillDate | date:'dd-MMM-yyyy'}}</label>
                </div>
              </div>
            </div>

            <div class="col-print-1"></div>

            <div class="col-print-5">
              <div class="row margin-left-0px margin-right-0px" *ngIf="CurrentX_BillHeaderController && RXPrintBodyWithPatientDetails == 'true'">
                <div class="col-print-4">
                  <label class="margin-bottom-0px  font-weight-normal">Age / Gender:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px  float-left font-weight-normal">{{CurrentX_BillHeaderController.PatientGender}}/{{CurrentX_BillHeaderController.PatientAge}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px" *ngIf="CurrentX_BillHeaderController && RXPrintBodyWithPatientDetails == 'true'">
                <div class="col-print-4">
                  <label class="margin-bottom-0px  font-weight-normal">Telephone:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px  float-left font-weight-normal">{{CurrentX_BillHeaderController.PatientTelephoneNumber1}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Branch:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Branch}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Doctor:</label>
                </div>
                <div class="col-print-8" *ngIf="BillData2">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal"
                         *ngIf="BillData2.PrescriberName!='' && BillData2.PrescriberName!='null'">
                    {{BillData2.PrescriberName}}
                  </label>

                </div>
              </div>
            </div>
          </div>

          <!--<div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Receipt No:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-bold">{{ReceiptFormattedCode}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Date:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{BillDate | date:'dd-MMM-yyyy'}}</label>
                </div>
              </div>
            </div>

            <div class="col-print-1"></div>

            <div class="col-print-5">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Branch:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Branch}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Doctor:</label>
                </div>
                <div class="col-print-8" *ngIf="BillData2">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal" *ngIf="BillData2.PrescriberName!='' && BillData2.PrescriberName!='null'">{{BillData2.PrescriberName}}</label>
                </div>
              </div>
            </div>
          </div>-->

        </div>

        <div class="col-print-12">
          <div class="row margin-right-0px margin-left-0px">
            <div class="col-print-12">
              <div hidden class="row margin-left-0px margin-right-0px">
                <div class="col-print-1">
                  <label class="margin-bottom-0px font-weight-bold background-primary font-family width-35px text-align-center">
                    #
                  </label>
                </div>
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-weight-bold background-primary text-align-left font-family">
                    Item Description
                  </label>
                </div>
                <div class="col-print-1">
                  <label class="margin-bottom-0px font-weight-bold background-primary text-align-left font-family">
                    Batch
                  </label>
                </div>
                <div class="col-print-2">
                  <label class="margin-bottom-0px font-weight-bold background-primary text-align-left font-family">
                    Expiry
                  </label>
                </div>
                <div class="col-print-1">
                  <label class="margin-bottom-0px font-weight-bold background-primary text-align-left font-family">
                    Qty
                  </label>
                </div>
                <div class="col-print-1">
                  <label class="margin-bottom-0px font-weight-bold background-primary text-align-right font-family">
                    Price
                  </label>
                </div>
                <div class="col-print-1">
                  <label class="margin-bottom-0px font-weight-bold background-primary text-align-right font-family">
                    Tax %
                  </label>
                </div>
                <div class="col-print-1">
                  <label class="margin-bottom-0px font-weight-bold background-primary text-align-right font-family">
                    Net
                  </label>
                </div>
              </div>
              <div hidden class="row margin-left-0px margin-right-0px" *ngFor="let l of CurrentX_BillItemsController;let RowIndex = index">
                <div class="col-print-1">
                  <label class="margin-bottom-0px font-family text-align-center">
                    {{RowIndex+1}}
                  </label>
                </div>
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family text-align-center">
                    {{l.ItemDescription}}
                  </label>
                </div>
                <div class="col-print-1">
                  <label class="margin-bottom-0px font-family text-align-center">
                    {{l.BatchNo}}
                  </label>
                </div>
                <div class="col-print-2">
                  <label class="margin-bottom-0px font-family text-align-center">
                    {{l.ExpiryDate | date:'dd-MMM-yyyy'}}
                  </label>
                </div>
                <div class="col-print-1">
                  <label class="margin-bottom-0px font-family text-align-center">
                    {{l.Quantity}}
                  </label>
                </div>
                <div class="col-print-1">
                  <label class="margin-bottom-0px font-family text-align-right">
                    {{l.UnitPrice | number:'1.2-2'}}
                  </label>
                </div>
                <div class="col-print-1">
                  <label class="margin-bottom-0px font-family text-align-right">
                    {{l.Tax}}
                  </label>
                </div>
                <div class="col-print-1">
                  <label class="margin-bottom-0px font-family text-align-right">
                    {{(l.Quantity * l.UnitPrice)-(l.Quantity * l.UnitPrice * (l.Discount / 100)) | number:'1.2-2'}}
                  </label>
                </div>
              </div>
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">
                    <thead>
                      <tr>

                        <th class="font-weight-bold background-primary padding-top-0px padding-bottom-0px font-family text-align-center">
                          #
                        </th>

                        <th class="font-weight-bold background-primary text-align-left padding-top-0px padding-bottom-0px font-family">
                          Item Description
                        </th>
                        <th class="font-weight-bold background-primary text-align-left padding-top-0px padding-bottom-0px font-family">
                          Batch
                        </th>
                        <th class="font-weight-bold background-primary text-align-left padding-top-0px padding-bottom-0px font-family">
                          Expiry
                        </th>
                        <th class="font-weight-bold background-primary text-align-left padding-top-0px padding-bottom-0px font-family">
                          Qty
                        </th>

                        <th class="font-weight-bold background-primary text-align-right padding-top-0px padding-bottom-0px font-family">
                          Price
                        </th>
                        <th hidden class="font-weight-bold background-primary text-align-right padding-top-0px padding-bottom-0px font-family" *ngIf="Discount>0">
                          Dis(%)
                        </th>
                        <th class="font-weight-bold background-primary text-align-right padding-top-0px padding-bottom-0px font-family">
                          Tax %
                        </th>

                        <th class="font-weight-bold background-primary text-align-right padding-top-0px padding-bottom-0px font-family">
                          Net
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let l of CurrentX_BillItemsController;let RowIndex = index">
                        <td class="font-family padding-top-0px padding-bottom-0px text-align-left">{{RowIndex+1}}</td>
                        <td class="font-family padding-top-0px padding-bottom-0px text-align-left">{{l.ItemDescription}}</td>
                        <td class="font-family padding-top-0px padding-bottom-0px text-align-left">{{l.BatchNo}}</td>
                        <td class="font-family padding-top-0px padding-bottom-0px text-align-left">{{l.ExpiryDate | date:'dd-MMM-yyyy'}}</td>
                        <td class="font-family padding-top-0px padding-bottom-0px text-align-left">{{l.Quantity}}</td>
                        <!--<td class="font-family padding-top-2px padding-bottom-2px text-align-right"></td>-->
                        <td class="font-family padding-top-0px padding-bottom-0px text-align-right">{{l.UnitPrice | number:'1.2-2'}}</td>
                        <td hidden class="font-family padding-top-0px padding-bottom-0px text-align-right" *ngIf="Discount>0">{{l.Discount | number:'1.2-2'}}</td>
                        <td class="font-family padding-top-0px padding-bottom-0px text-align-right">{{l.Tax}}</td>
                        <!--<td class="font-family padding-top-2px padding-bottom-2px text-align-right"></td>-->
                        <td class="font-family padding-top-0px padding-bottom-0px text-align-right">{{(l.Quantity * l.UnitPrice)-(l.Quantity * l.UnitPrice * (l.Discount / 100)) | number:'1.2-2'}}</td>

                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>

        </div>


        <div class="col-print-12">
          <div class="row margin-right-0px margin-left-0px">
            <div class="col-print-12">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">
                    <thead>
                      <tr>
                        <th class="font-weight-normal background-primary padding-top-0px padding-bottom-0px font-family text-align-left">
                          Grand Total
                        </th>
                        <!--<th class="font-weight-normal background-primary padding-top-0px padding-bottom-0px font-family text-align-left">
                      Before Tax
                    </th>-->

                        <th class="font-weight-normal background-primary text-align-right padding-top-0px padding-bottom-0px font-family" *ngIf="Discount>0">
                          Discount
                        </th>
                        <th class="font-weight-normal background-primary text-align-right padding-top-0px padding-bottom-0px font-family">
                          Tax
                        </th>
                        <th class="font-weight-normal background-primary text-align-right padding-top-0px padding-bottom-0px font-family">
                          Net (rounded)
                        </th>
                        <!--<th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                      Paid
                    </th>-->
                        <th class="font-weight-normal background-primary text-align-right padding-top-0px padding-bottom-0px font-family">
                          Due
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="font-family padding-top-0px padding-bottom-0px text-align-left">{{GrandTotal | number:'1.0-2'}}</td>
                        <!--<td class="font-family padding-top-0px padding-bottom-0px text-align-left">{{GrandTotal - Tax | number:'1.0-2'}}</td>-->
                        <td class="font-family padding-top-0px padding-bottom-0px text-align-right" *ngIf="Discount>0">{{Discount | number:'1.0-2'}}</td>
                        <td class="font-family padding-top-0px padding-bottom-0px text-align-right">{{Tax | number:'1.0-2'}}</td>
                        <td class="font-family padding-top-0px padding-bottom-0px text-align-right">{{Net | number:'1.2-2'}}</td>
                        <!--<td class="font-family padding-top-2px padding-bottom-2px text-align-right">{{Net - Due | number:'1.2-2'}}</td>-->
                        <td class="font-family padding-top-0px padding-bottom-0px text-align-right">{{Due | number:'1.0-2'}}</td>
                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-10">
              <label class="margin-bottom-0px font-family font-weight-normal">Amount In Words: {{Net - Due | amountToWord}}</label>
            </div>
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family float-right font-weight-bold">{{Net - Due | number:'1.2-2'}}</label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-bold">Cashier:</label>
            </div>
            <div class="col-print-6" *ngIf="CurrentX_BillHeaderController">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">{{CurrentX_BillHeaderController.PayeeName}}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row margin-left-0px margin-right-0px" *ngIf="RXDotMatrixPrint == 'true'">
  <div class="col-print-12 padding-left-0px">
    <div class="card background-color-wt">

      <div class="card-body padding-top-0px padding-bottom-0px font-weight-normal background-color-wt">

        <div class="row bordertop5px">
          <div class="col-print-12 text-align-center">
            <label [style.font-family]="RXFontFamily"
                   [style.font-size.px]="RXFontSize"
                   class="margin-bottom-0px">{{RXBillTitle}}</label>
            <!--<qrcode class="padding-top-0px padding-bottom-0px qr-style7" [qrdata]="PatientId" [size]="90" [level]="'M'"></qrcode>-->
          </div>
        </div>

        <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <div class="row margin-left-0px margin-right-0px" *ngIf="CurrentX_BillHeaderController && RXPrintBodyWithPatientDetails == 'true'">
                <div class="col-print-5">
                  <label class="margin-bottom-0px  font-weight-normal"
                         [style.font-family]="RXFontFamily"
                         [style.font-size.px]="RXFontSize">Patient Name:</label>
                </div>
                <div class="col-print-7">
                  <label [style.font-family]="RXFontFamily"
                         [style.font-size.px]="RXFontSize"
                         class="margin-bottom-0px  float-left font-weight-normal">{{CurrentX_BillHeaderController.PatientName}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px" *ngIf="CurrentX_BillHeaderController && RXPrintBodyWithPatientDetails == 'true'">
                <div class="col-print-5">
                  <label [style.font-family]="RXFontFamily"
                         [style.font-size.px]="RXFontSize"
                         class="margin-bottom-0px  font-weight-normal">ID:</label>
                </div>
                <div class="col-print-7">
                  <label [style.font-family]="RXFontFamily"
                         [style.font-size.px]="RXFontSize"
                         class="margin-bottom-0px  float-left font-weight-normal">{{CurrentX_BillHeaderController.PatientFormattedCode}}</label>
                </div>
              </div>

              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-5">
                  <label [style.font-family]="RXFontFamily"
                         [style.font-size.px]="RXFontSize"
                         class="margin-bottom-0px font-weight-normal">Receipt No:</label>
                </div>
                <div class="col-print-7">
                  <label [style.font-family]="RXFontFamily"
                         [style.font-size.px]="RXFontSize"
                         class="margin-bottom-0px float-left font-weight-normal">{{ReceiptFormattedCode}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-5">
                  <label [style.font-family]="RXFontFamily"
                         [style.font-size.px]="RXFontSize"
                         class="margin-bottom-0px font-weight-normal">Date:</label>
                </div>
                <div class="col-print-7">
                  <label [style.font-family]="RXFontFamily"
                         [style.font-size.px]="RXFontSize"
                         class="margin-bottom-0px float-left font-weight-normal">{{BillDate | date:'dd-MMM-yyyy'}}</label>
                </div>
              </div>
            </div>

            <div class="col-print-1"></div>

            <div class="col-print-5">
              <div class="row margin-left-0px margin-right-0px" *ngIf="CurrentX_BillHeaderController && RXPrintBodyWithPatientDetails == 'true'">
                <div class="col-print-5">
                  <label [style.font-family]="RXFontFamily"
                         [style.font-size.px]="RXFontSize"
                         class="margin-bottom-0px  font-weight-normal">Age / Gender:</label>
                </div>
                <div class="col-print-7">
                  <label [style.font-family]="RXFontFamily"
                         [style.font-size.px]="RXFontSize"
                         class="margin-bottom-0px  float-left font-weight-normal">{{CurrentX_BillHeaderController.PatientGender}}/{{CurrentX_BillHeaderController.PatientAge}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px" *ngIf="CurrentX_BillHeaderController && RXPrintBodyWithPatientDetails == 'true'">
                <div class="col-print-5">
                  <label [style.font-family]="RXFontFamily"
                         [style.font-size.px]="RXFontSize"
                         class="margin-bottom-0px  font-weight-normal">Telephone:</label>
                </div>
                <div class="col-print-7">
                  <label [style.font-family]="RXFontFamily"
                         [style.font-size.px]="RXFontSize"
                         class="margin-bottom-0px  float-left font-weight-normal">{{CurrentX_BillHeaderController.PatientTelephoneNumber1}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-5">
                  <label [style.font-family]="RXFontFamily"
                         [style.font-size.px]="RXFontSize"
                         class="margin-bottom-0px font-weight-normal">Branch:</label>
                </div>
                <div class="col-print-7">
                  <label [style.font-family]="RXFontFamily"
                         [style.font-size.px]="RXFontSize"
                         class="margin-bottom-0px float-left font-weight-normal">{{Branch}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-5">
                  <label [style.font-family]="RXFontFamily"
                         [style.font-size.px]="RXFontSize"
                         class="margin-bottom-0px font-weight-normal">Doctor:</label>
                </div>
                <div class="col-print-7" *ngIf="BillData2">
                  <label [style.font-family]="RXFontFamily"
                         [style.font-size.px]="RXFontSize"
                         class="margin-bottom-0px float-left font-weight-normal"
                         *ngIf="BillData2.PrescriberName!='' && BillData2.PrescriberName!='null'">
                    {{BillData2.PrescriberName}}
                  </label>

                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="col-print-12">
          <div class="row margin-right-0px margin-left-0px">
            <div class="col-print-12">
              <div hidden class="row margin-left-0px margin-right-0px">
                <div class="col-print-1">
                  <label class="margin-bottom-0px font-weight-bold background-primary font-family width-35px text-align-center">
                    #
                  </label>
                </div>
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-weight-bold background-primary text-align-left font-family">
                    Item Description
                  </label>
                </div>
                <div class="col-print-1">
                  <label class="margin-bottom-0px font-weight-bold background-primary text-align-left font-family">
                    Batch
                  </label>
                </div>
                <div class="col-print-2">
                  <label class="margin-bottom-0px font-weight-bold background-primary text-align-left font-family">
                    Expiry
                  </label>
                </div>
                <div class="col-print-1">
                  <label class="margin-bottom-0px font-weight-bold background-primary text-align-left font-family">
                    Qty
                  </label>
                </div>
                <div class="col-print-1">
                  <label class="margin-bottom-0px font-weight-bold background-primary text-align-right font-family">
                    Price
                  </label>
                </div>
                <div class="col-print-1">
                  <label class="margin-bottom-0px font-weight-bold background-primary text-align-right font-family">
                    Tax %
                  </label>
                </div>
                <div class="col-print-1">
                  <label class="margin-bottom-0px font-weight-bold background-primary text-align-right font-family">
                    Net
                  </label>
                </div>
              </div>
              <div hidden class="row margin-left-0px margin-right-0px" *ngFor="let l of CurrentX_BillItemsController;let RowIndex = index">
                <div class="col-print-1">
                  <label class="margin-bottom-0px font-family text-align-center">
                    {{RowIndex+1}}
                  </label>
                </div>
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family text-align-center">
                    {{l.ItemDescription}}
                  </label>
                </div>
                <div class="col-print-1">
                  <label class="margin-bottom-0px font-family text-align-center">
                    {{l.BatchNo}}
                  </label>
                </div>
                <div class="col-print-2">
                  <label class="margin-bottom-0px font-family text-align-center">
                    {{l.ExpiryDate | date:'dd-MMM-yyyy'}}
                  </label>
                </div>
                <div class="col-print-1">
                  <label class="margin-bottom-0px font-family text-align-center">
                    {{l.Quantity}}
                  </label>
                </div>
                <div class="col-print-1">
                  <label class="margin-bottom-0px font-family text-align-right">
                    {{l.UnitPrice | number:'1.2-2'}}
                  </label>
                </div>
                <div class="col-print-1">
                  <label class="margin-bottom-0px font-family text-align-right">
                    {{l.Tax}}
                  </label>
                </div>
                <div class="col-print-1">
                  <label class="margin-bottom-0px font-family text-align-right">
                    {{(l.Quantity * l.UnitPrice)-(l.Quantity * l.UnitPrice * (l.Discount / 100)) | number:'1.2-2'}}
                  </label>
                </div>
              </div>
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">
                    <thead>
                      <tr>

                        <th [style.font-family]="RXFontFamily"
                            [style.font-size.px]="RXFontSize"                            
                            class="background-primary padding-top-0px padding-bottom-0px text-align-left">
                          #
                        </th>

                        <th [style.font-family]="RXFontFamily"
                            [style.font-size.px]="RXFontSize"                            
                            class="background-primary text-align-left padding-top-0px padding-bottom-0px">
                          Item Description
                        </th>
                        <!--<th [style.font]="RXDmFont" class="font-weight-normal background-primary text-align-left padding-top-0px padding-bottom-0px">
                          Batch
                        </th>
                        <th [style.font]="RXDmFont" class="font-weight-normal background-primary text-align-left padding-top-0px padding-bottom-0px">
                          Expiry
                        </th>-->
                        <th [style.font-family]="RXFontFamily"
                            [style.font-size.px]="RXFontSize"                            
                            class="background-primary text-align-left padding-top-0px padding-bottom-0px">
                          Qty
                        </th>

                        <th [style.font-family]="RXFontFamily"
                            [style.font-size.px]="RXFontSize"
                            
                            class="background-primary text-align-right padding-top-0px padding-bottom-0px">
                          Price
                        </th>
                        <th hidden class="background-primary text-align-right padding-top-0px padding-bottom-0px" *ngIf="Discount>0">
                          Dis(%)
                        </th>
                        <th [style.font-family]="RXFontFamily"
                            [style.font-size.px]="RXFontSize"
                            
                            class="background-primary text-align-right padding-top-0px padding-bottom-0px">
                          Tax %
                        </th>

                        <th [style.font-family]="RXFontFamily"
                            [style.font-size.px]="RXFontSize"
                            
                            class="background-primary text-align-right padding-top-0px padding-bottom-0px">
                          Net
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let l of CurrentX_BillItemsController;let RowIndex = index">
                        <td [style.font-family]="RXFontFamily"
                            [style.font-size.px]="RXFontSize"
                            class="font-weight-normal padding-top-0px padding-bottom-0px text-align-left">{{RowIndex+1}}</td>
                        <td
                            class="padding-top-0px padding-bottom-0px">
                          <div [style.font-family]="RXFontFamily"
                               [style.font-size.px]="RXFontSize"
                               class="row font-weight-normal text-align-left margin-right-0px margin-left-0px">{{l.ItemDescription}}</div>
                          <div [style.font-family]="RXFontFamily"
                               [style.font-size.px]="RXFontSize"
                               class="row font-weight-normal text-align-left margin-right-0px margin-left-0px">{{l.BatchNo}} , {{l.ExpiryDate | date:'dd-MMM-yyyy'}}</div>
                        </td>
                        <!--<td [style.font]="RXDmFont" class="padding-top-0px padding-bottom-0px text-align-left">{{l.BatchNo}}</td>
                        <td [style.font]="RXDmFont" class="padding-top-0px padding-bottom-0px text-align-left">{{l.ExpiryDate | date:'dd-MMM-yyyy'}}</td>-->
                        <td [style.font-family]="RXFontFamily"
                            [style.font-size.px]="RXFontSize"
                            class="padding-top-0px font-weight-normal padding-bottom-0px text-align-left">{{l.Quantity}}</td>
                        <!--<td class="font-family padding-top-2px padding-bottom-2px text-align-right"></td>-->
                        <td [style.font-family]="RXFontFamily"
                            [style.font-size.px]="RXFontSize"
                            class="padding-top-0px font-weight-normal padding-bottom-0px text-align-right">{{l.UnitPrice | number:'1.2-2'}}</td>
                        <td hidden class="font-family padding-top-0px padding-bottom-0px text-align-right" *ngIf="Discount>0">{{l.Discount | number:'1.2-2'}}</td>
                        <td [style.font-family]="RXFontFamily"
                            [style.font-size.px]="RXFontSize"
                            class="padding-top-0px font-weight-normal padding-bottom-0px text-align-right">{{l.Tax}}</td>
                        <!--<td class="font-family padding-top-2px padding-bottom-2px text-align-right"></td>-->
                        <td [style.font-family]="RXFontFamily"
                            [style.font-size.px]="RXFontSize"
                            class="padding-top-0px font-weight-normal padding-bottom-0px text-align-right">{{(l.Quantity * l.UnitPrice)-(l.Quantity * l.UnitPrice * (l.Discount / 100)) | number:'1.2-2'}}</td>

                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>

        </div>


        <div class="col-print-12">
          <div class="row margin-right-0px margin-left-0px">
            <div class="col-print-12">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">
                    <thead>
                      <tr>
                        <th [style.font-family]="RXFontFamily"
                            [style.font-size.px]="RXFontSize"
                            class="background-primary padding-top-0px padding-bottom-0px text-align-left">
                          Grand Total
                        </th>
                        <!--<th class="font-weight-normal background-primary padding-top-0px padding-bottom-0px font-family text-align-left">
                          Before Tax
                        </th>-->

                        <th [style.font-family]="RXFontFamily"
                            [style.font-size.px]="RXFontSize"
                            class="background-primary text-align-right padding-top-0px padding-bottom-0px" *ngIf="Discount>0">
                          Discount
                        </th>
                        <th [style.font-family]="RXFontFamily"
                            [style.font-size.px]="RXFontSize"
                            class="background-primary text-align-right padding-top-0px padding-bottom-0px">
                          Tax
                        </th>
                        <th [style.font-family]="RXFontFamily"
                            [style.font-size.px]="RXFontSize"
                            class="background-primary text-align-right padding-top-0px padding-bottom-0px">
                          Net (rounded)
                        </th>
                        <!--<th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Paid
                        </th>-->
                        <th [style.font-family]="RXFontFamily"
                            [style.font-size.px]="RXFontSize"
                            class="background-primary text-align-right padding-top-0px padding-bottom-0px">
                          Due
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td [style.font-family]="RXFontFamily"
                            [style.font-size.px]="RXFontSize"
                            class="padding-top-0px font-weight-normal padding-bottom-0px text-align-left">{{GrandTotal | number:'1.0-2'}}</td>
                        <!--<td class="font-family padding-top-0px padding-bottom-0px text-align-left">{{GrandTotal - Tax | number:'1.0-2'}}</td>-->
                        <td [style.font-family]="RXFontFamily"
                            [style.font-size.px]="RXFontSize"
                            class="padding-top-0px font-weight-normal padding-bottom-0px text-align-right" *ngIf="Discount>0">{{Discount | number:'1.0-2'}}</td>
                        <td [style.font-family]="RXFontFamily"
                            [style.font-size.px]="RXFontSize"
                            class="padding-top-0px font-weight-normal padding-bottom-0px text-align-right">{{Tax | number:'1.0-2'}}</td>
                        <td [style.font-family]="RXFontFamily"
                            [style.font-size.px]="RXFontSize"
                            class="padding-top-0px font-weight-normal padding-bottom-0px text-align-right">{{Net | number:'1.2-2'}}</td>
                        <!--<td class="font-family padding-top-2px padding-bottom-2px text-align-right">{{Net - Due | number:'1.2-2'}}</td>-->
                        <td [style.font-family]="RXFontFamily"
                            [style.font-size.px]="RXFontSize"
                            class="padding-top-0px font-weight-normal padding-bottom-0px text-align-right">{{Due | number:'1.0-2'}}</td>
                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-10">
              <label [style.font-family]="RXFontFamily"
                     [style.font-size.px]="RXFontSize"
                     class="margin-bottom-0px font-weight-normal">Amount In Words: {{Net - Due | amountToWord}}</label>
            </div>
            <div class="col-print-2">
              <label [style.font-family]="RXFontFamily"
                     [style.font-size.px]="RXFontSize"
                     class="margin-bottom-0px float-right font-weight-normal">{{Net - Due | number:'1.2-2'}}</label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label [style.font-family]="RXFontFamily"
                     [style.font-size.px]="RXFontSize"
                     class="margin-bottom-0px font-weight-normal">Cashier:</label>
            </div>
            <div class="col-print-6" *ngIf="CurrentX_BillHeaderController">
              <label [style.font-family]="RXFontFamily"
                     [style.font-size.px]="RXFontSize"
                     class="margin-bottom-0px float-left font-weight-normal">{{CurrentX_BillHeaderController.PayeeName}}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--<printfooterview></printfooterview>-->
